import { Icon } from '@iconify/react'
import { useTranslation } from '@echodex/localization'
import { useTooltip } from '@echodex/uikit'
import { ButtonHTMLAttributes } from 'react'
import styled from 'styled-components'

const StyledButton = styled.button`
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), inset 0px 2px 4px rgba(228, 228, 228, 0.25);
`

export const ButtonRemove = (props: ButtonHTMLAttributes<HTMLButtonElement> & { tooltipText?: string }) => {
    const { t } = useTranslation()
    const { targetRef, tooltip, tooltipVisible } = useTooltip(t(props.tooltipText), { placement: 'top' })
    return (
        <>
            <StyledButton
                ref={props.tooltipText ? targetRef : undefined}
                className="minus bg-gray h-[36px] w-[36px] rounded-xl flex-center cursor-pointer"
                {...props}
            >
                <Icon icon="ic:round-minus" className="text-[24px] text-[#D979B1]" />
            </StyledButton>
            {props.tooltipText && tooltipVisible && tooltip}
        </>
    )
}

export const ButtonAdd = (props: ButtonHTMLAttributes<HTMLButtonElement> & { tooltipText?: string }) => {
    const { t } = useTranslation()
    const { targetRef, tooltip, tooltipVisible } = useTooltip(t(props.tooltipText), { placement: 'top' })

    return (
        <>
            <StyledButton
                ref={props.tooltipText ? targetRef : undefined}
                className="minus bg-gray h-[36px] w-[36px] rounded-xl flex-center cursor-pointer"
                {...props}
                onClick={props.onClick}
            >
                <Icon icon="ic:round-plus" className="text-[24px] text-pri" />
            </StyledButton>
            {props.tooltipText && tooltipVisible && tooltip}
        </>
    )
}

export const ButtonFarm = (props: ButtonHTMLAttributes<HTMLButtonElement> & { tooltipText?: string }) => {
    const { t } = useTranslation()
    const { targetRef, tooltip, tooltipVisible } = useTooltip(t(props.tooltipText), { placement: 'top' })

    return (
        <>
            <StyledButton
                ref={props.tooltipText ? targetRef : undefined}
                className="minus bg-gray h-[36px] w-[36px] rounded-xl flex-center cursor-pointer"
                {...props}
                onClick={props.onClick}
            >
                <Icon icon="game-icons:farm-tractor" className="text-[24px] text-pri" />
            </StyledButton>
            {props.tooltipText && tooltipVisible && tooltip}
        </>
    )
}
